

export const getStatus = (status) => {
    
    let new_status="";
    switch (status) {
        case 0:
          new_status =  "INCOMPLETE; PENDING PATIENT AUTHORIZATION";
          break;
        case 0.5:
          new_status =  "PENDING FACILITY ASSIGNMENT";
          break;
        case 1:
           new_status =  "PENDING ADMINISTRATIVE ACTION";
          break;
        case 2:
          new_status =  "PENDING CLIENT/AGENT ACTION";
          break;
        case 3:
          new_status =  "PENDING ACTION";
          break;
        case 4:
          new_status =  "RECORDS OBTAINED; WAITING TO BE INVOICED";
          break;
        case 5:
          new_status =  "RECORDS OBTAINED; INVOICE GENERATED";
        case 6:
          new_status =  "RECORDS OBTAINED; PAYMENT(S) RECEIVED";
        case 7:
          new_status =  "CLOSED";  
        case 8:
            new_status =  "ARCHIVED";        
      }
      return new_status;
}



export const validatePhone = (phone) => {
    
  if(!phone) return true;

  let phone_regrex = /^(\()?\d{3}(\))?(-|\s)?\d{3}(-|\s)\d{4}$/;
  
  if(!phone_regrex.test(phone))
    return false
  
  return true;
}


export const validateAmount = (amount) => {
    
  if(!amount) return true;

  const amount_regrex = /^[0-9]*\.\d{1,2}$/;
  
  if(!amount_regrex.test(amount))
    return false
  
  return true;

}


export const validateEmail = (email) => {
    
  if(!email) return true;

  const email_regrex = /^$|^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  
  if(!email_regrex.test(email))
    return false;
  
  return true;

}
